import { render, staticRenderFns } from "./LogisticsTopBar.vue?vue&type=template&id=0bd03738&scoped=true"
import script from "./LogisticsTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogisticsTopBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LogisticsTopBar.vue?vue&type=style&index=0&id=0bd03738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd03738",
  null
  
)

export default component.exports